import { Suspense, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';

import Router from './router/Router';
import Loader from './components/ui/Loader/Loader';
import { revalidateToken } from './helper/revalidateToken';
import 'react-toastify/dist/ReactToastify.css';

function App() {
	const dispatch = useDispatch();
	const key = useSelector((state) => state.auth.key);
	const user = useSelector((state) => state.auth.user);
	const refresh = useSelector((state) => state.auth.refresh);
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const shouldRefresh = useSelector((state) => state.auth.shouldRefresh);
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retryDelay: 3000,
				throwOnError: true,
				useErrorBoundary: true,
			},
		},
		queryCache: new QueryCache({
			onError: async (error) => {
				if (error.response?.status === 401 && refresh) {
					const res = await revalidateToken(refresh)
					if (res.error && res.status === 401) {
						dispatch({ type: 'auth/setLogout' });
						return
					}

					dispatch({ type: 'auth/setNewAuth', payload: res });
				} else {
					throw new Error(error)
				}
			},
		}),
	});
	useEffect(() => {
		if (isAuthenticated === null && key && user) {
			dispatch({ type: 'auth/setAuthenticated' });
		}
	});
	useEffect(() => {
		if (shouldRefresh) {
			dispatch({ type: 'auth/setNewKeyValue', payload: { key: 'shouldRefresh', value: false } });
			window.location.reload()
		}
	}, [shouldRefresh, dispatch]);
	return (
		<QueryClientProvider client={queryClient}>
			<Suspense fallback={<Loader />}>
				<ToastContainer position='bottom-right' autoClose={2000} newestOnTop={false} closeOnClick />
				<Router />
			</Suspense>
		</QueryClientProvider>
	);
}

export default App;
